// Games Expansion V1: thin wrapper around the PostHog snippet already
// loaded globally in public/index.html. No-ops safely if PostHog hasn't
// loaded (offline, blocked, etc.) so a game never throws over analytics.
export function trackGameEvent(name, props = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture(name, props);
    }
  } catch {
    // analytics must never break gameplay
  }
}
